import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const aboutHeroImage = 'https://readdy.ai/api/search-image?query=Dark%20elegant%20abstract%20photography%20of%20flowing%20ink%20in%20water%20creating%20mysterious%20swirling%20patterns%20against%20deep%20black%20background%20subtle%20golden%20and%20crimson%20accents%20fine%20art%20minimalist%20composition%20sophisticated%20atmosphere%20no%20text%20no%20people&width=1400&height=800&seq=about-hero&orientation=landscape';

const teamImage = 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20photography%20of%20a%20group%20of%20silhouetted%20journalists%20working%20in%20a%20dimly%20lit%20newsroom%20with%20multiple%20monitors%20glowing%20dramatic%20shadows%20serious%20investigative%20atmosphere%20editorial%20photography%20style%20deep%20charcoal%20tones%20with%20warm%20accent%20lights&width=600&height=800&seq=about-team&orientation=portrait';

export default function AboutPage() {
  const faqData = [
    { q: '51黑料不打烊的内容来源是什么？', a: '我们的内容主要来源于网友投稿、公开信息整理、以及多方独立信源的交叉验证。所有爆料信息在发布前都会经过编辑团队的审核与核实，力求内容的真实性和可靠性。' },
    { q: '如何在51黑料上观看视频黑料？', a: '您可以在51黑料网站首页和分类页面浏览到最新视频黑料内容。部分视频可能需要点击播放按钮进行观看。我们持续优化视频播放体验，确保流畅稳定的观看效果。' },
    { q: '51黑料在线看的入口在哪里？', a: '51黑料在线看入口即为我们的官方网站首页。您也可以收藏本站，或通过搜索引擎搜索"51黑料不打烊"找到我们。我们确保入口稳定，让用户随时都能访问。' },
    { q: '爆料人的隐私是否受到保护？', a: '绝对保护。我们采用最严格的信息加密措施来保护每一位爆料人的隐私安全。所有投稿均经过脱敏处理，确保爆料人信息不会泄露。' },
    { q: '51黑料吃瓜视频多久更新一次？', a: '我们的内容团队保持7×24小时全天候更新机制，确保用户在第一时间获取最新、最热的吃瓜视频和爆料资讯。重大事件发生时，我们会在数分钟内完成内容更新。' },
  ];

  // Schema.org structured data
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51黑料不打烊',
    url: 'https://51heilian.com/',
    logo: {
      '@type': 'ImageObject',
      url: 'https://51heilian.com/logo.png',
    },
    description: '娱乐八卦爆料内容聚合平台',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@51heilian.com',
      availableLanguage: 'Chinese',
    },
    sameAs: [
      'https://weibo.com/51heilian',
      'https://space.bilibili.com/51heilian',
    ],
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    url: 'https://51heilian.com/about',
    name: '关于我们 - 51黑料不打烊',
    description: '了解51黑料不打烊平台，娱乐八卦爆料内容聚合平台，品牌介绍、平台数据、商务合作联系方式。',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      url: 'https://51heilian.com/',
      name: '51黑料不打烊',
    },
    mainEntity: {
      '@type': 'Organization',
      name: '51黑料不打烊',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://51heilian.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'https://51heilian.com/about',
      },
    ],
  };

  const faqPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageSchema) }} />
      <Navbar />

      <main>
        {/* Breadcrumb */}
        <section className="pt-24 md:pt-32 px-4 md:px-6 lg:px-10">
          <div className="max-w-[1200px] mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-400" aria-label="面包屑导航">
              <a href="/" className="hover:text-accent-500 transition-colors">首页</a>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-accent-500">关于我们</span>
            </nav>
          </div>
        </section>

        {/* About Hero */}
        <section className="py-10 md:py-16 px-4 md:px-6 lg:px-10">
          <div className="max-w-[1200px] mx-auto">
            <div className="flex flex-col lg:flex-row gap-8 md:gap-16">
              {/* Left - Brand & Image */}
              <div className="lg:w-1/3">
                <span className="border border-accent-500/40 text-accent-400 bg-accent-500/10 tag-pill mb-4">品牌标识</span>
                <div className="relative aspect-[3/4] rounded-3xl overflow-hidden mt-4">
                  <img src={teamImage} alt="51黑料团队工作场景" className="w-full h-full object-cover" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                </div>
              </div>

              {/* Right - Brand Statement */}
              <div className="lg:w-2/3 flex flex-col justify-center">
                <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight mb-4">
                  关于<strong className="text-primary-500 font-heading">51黑料</strong>不打烊
                </h1>
                <p className="text-xl md:text-2xl text-foreground-600 font-heading italic mb-6">真相不会被掩埋，吃瓜从不打烊</p>

                <div className="space-y-4 text-foreground-500 text-sm md:text-base leading-relaxed">
                  <p>
                    <strong className="text-foreground-800">51黑料不打烊</strong>成立于2024年，是一个专注于娱乐八卦与深度爆料的聚合平台。我们致力于为吃瓜群众提供最新、最全、最真实的娱乐资讯与爆料内容。
                  </p>
                  <p>
                    在这个信息爆炸的时代，每天都有海量的娱乐八卦涌现，但真假难辨。51黑料不打烊通过多渠道交叉验证与深度挖掘，为用户筛选出最有价值的<strong className="text-foreground-800">爆料内容</strong>，让大家吃瓜吃得放心、吃得过瘾。
                  </p>
                  <p>
                    我们的团队由资深娱乐记者、数据分析师和技术极客组成，秉持"<strong className="text-primary-500">真实、客观、深度</strong>"的原则，打造了一个集<strong className="text-accent-500">视频黑料、图文实锤、深度追踪</strong>于一体的综合性吃瓜社区。
                  </p>
                  <p>
                    无论你是想第一时间了解<strong className="text-foreground-800">最新塌房现场</strong>，还是回味经典八卦盛况，51黑料不打烊都能满足你的吃瓜需求。我们的平台覆盖<strong className="text-foreground-800">51黑料在线观看、51黑料吃瓜视频、51黑料网站入口</strong>等全方位服务。
                  </p>
                </div>

                <div className="mt-8">
                  <a href="/category/mingxing-bagua" className="btn-primary inline-flex items-center gap-2">
                    开始探索 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation / Testimonials */}
        <section className="py-14 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100/50">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-10 md:mb-16">
              <span className="text-accent-500 font-heading text-lg md:text-xl">〖 媒体口碑 〗</span>
              <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 mt-3">
                行业<strong className="text-primary-500">认可</strong>
              </h2>
            </div>

            {/* Trust Score */}
            <div className="flex justify-center mb-10">
              <div className="bg-background-50 border border-background-200 rounded-2xl px-8 py-5 flex items-center gap-4">
                <div className="flex items-center">
                  <i className="ri-shield-star-line text-accent-500 text-3xl"></i>
                </div>
                <div>
                  <div className="flex items-center gap-1 mb-1">
                    <i className="ri-star-fill text-accent-500"></i>
                    <i className="ri-star-fill text-accent-500"></i>
                    <i className="ri-star-fill text-accent-500"></i>
                    <i className="ri-star-fill text-accent-500"></i>
                    <i className="ri-star-half-line text-accent-500"></i>
                  </div>
                  <p className="text-foreground-950 font-label font-bold text-2xl">4.7 <span className="text-foreground-400 text-sm font-normal">平台信任指数</span></p>
                </div>
              </div>
            </div>

            {/* Testimonial Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-12">
              {[
                {
                  quote: '51黑料不打烊在娱乐八卦聚合领域做出了差异化，其内容审核机制和信源追溯体系值得行业借鉴。',
                  author: '娱乐周刊',
                  role: '资深编辑',
                },
                {
                  quote: '作为一个吃瓜多年的老用户，51黑料的内容质量和更新速度是我见过最顶的，信息可信度远超同类平台。',
                  author: '数码观察',
                  role: '科技媒体记者',
                },
                {
                  quote: '51黑料在事件深度追踪方面表现出色，多次在重大娱乐事件中率先披露关键信息，已成为行业重要参考源。',
                  author: '深度报道',
                  role: '特约评论员',
                },
              ].map((item, i) => (
                <div key={i} className="bg-background-50 rounded-2xl p-6 md:p-7">
                  <div className="w-2 h-12 md:h-16 bg-accent-500/30 rounded-full mb-4"></div>
                  <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
                    &ldquo;{item.quote}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full border-2 border-accent-500/30 bg-background-100 flex items-center justify-center">
                      <span className="text-foreground-500 font-label text-xs">{item.author[0]}</span>
                    </div>
                    <div>
                      <p className="text-foreground-800 text-sm font-label">{item.author}</p>
                      <p className="text-foreground-400 text-xs">{item.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Nav Dots */}
            <div className="flex items-center justify-center gap-2">
              <button className="w-3 h-3 rounded-full bg-accent-500"></button>
              <button className="w-3 h-3 rounded-full bg-background-300 hover:bg-background-400 transition-colors"></button>
              <button className="w-3 h-3 rounded-full bg-background-300 hover:bg-background-400 transition-colors"></button>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-14 md:py-20 px-4 md:px-6 lg:px-10">
          <div className="max-w-[1200px] mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
              {[
                { value: '12,000+', label: '累计爆料', icon: 'ri-file-text-line' },
                { value: '850万+', label: '月活跃用户', icon: 'ri-user-line' },
                { value: '98.7%', label: '信息准确率', icon: 'ri-check-double-line' },
                { value: '24h', label: '全天候更新', icon: 'ri-time-line' },
              ].map((stat, i) => (
                <div key={i} className="text-center p-6 rounded-2xl bg-background-100 hover:bg-background-200 transition-colors duration-300">
                  <div className="w-12 h-12 mx-auto rounded-xl bg-background-50 flex items-center justify-center mb-4">
                    <i className={`${stat.icon} text-accent-500 text-xl`}></i>
                  </div>
                  <p className="text-2xl md:text-3xl font-black text-foreground-950 font-label">{stat.value}</p>
                  <p className="text-foreground-400 text-xs md:text-sm mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-14 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100/50">
          <div className="max-w-[1200px] mx-auto text-center">
            <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mb-4">
              加入<strong className="text-primary-500 font-heading">我们</strong>
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto mb-8">
              如果你有独家爆料线索，欢迎联系我们。我们严格保护爆料人隐私，让每一个声音都被听见。
            </p>
            <div className="flex items-center justify-center gap-3 flex-wrap">
              <a href="/category/mingxing-bagua" className="btn-accent inline-flex items-center gap-2">
                <i className="ri-send-plane-line"></i> 立即爆料
              </a>
              <a href="/" className="btn-outline inline-flex items-center gap-2">
                浏览爆料
              </a>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 px-4 md:px-6 lg:px-10">
          <div className="max-w-[900px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950">
                常见<strong className="text-secondary-500">问题</strong>
              </h2>
            </div>

            <div className="space-y-3 md:space-y-4">
              {faqData.map((faq, i) => (
                <details key={i} className="group bg-background-100 rounded-2xl overflow-hidden">
                  <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer hover:bg-background-200 transition-colors duration-200">
                    <span className="text-foreground-800 font-heading text-sm md:text-base pr-4">{faq.q}</span>
                    <i className="ri-add-line text-foreground-400 group-open:hidden shrink-0"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:block shrink-0"></i>
                  </summary>
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-foreground-500 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}